/**
 * Telling a figure from a label, the way a financial table is read.
 *
 * Pure. Shared by every import that rebuilds a table (Word, Excel, PDF), so a
 * column of figures is recognised the same way whichever file it came from.
 */

/** Whether a cell's text reads as a figure rather than a label. */
export function looksNumeric(value: string): boolean {
  const trimmed = value.trim()
  if (!trimmed) return false

  // Strip what a financial figure legitimately carries: currency, thousands
  // separators of either convention, a percentage, and accounting parentheses
  // for a negative.
  const bare = trimmed
    .replace(/^\(|\)$/g, '')
    .replace(/[\s ]/g, '')
    .replace(/[€$£%]/g, '')
    .replace(/[.,](?=\d{3}\b)/g, '')
    .replace(',', '.')

  return bare !== '' && Number.isFinite(Number(bare))
}
